export enum FeatureFlag {
  GROWTH_WEBSITE_BANNER = "GROWTH_WEBSITE_BANNER",
  WEB_SCHEDULING_DOUBLE_BOOKING_GUARD_ENABLED = "WEB_SCHEDULING_DOUBLE_BOOKING_GUARD_ENABLED",
}
